import React from 'react';

const CTA: React.FC = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-purple-900 via-violet-800 to-fuchsia-900 relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-fuchsia-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* 装飾的な図形 */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 border-2 border-fuchsia-400/30 rounded-full"></div>
        <div className="absolute bottom-1/4 right-1/4 w-48 h-48 border-2 border-violet-400/30" style={{ transform: 'rotate(45deg)' }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="inline-block px-8 py-3 bg-white/10 backdrop-blur-md rounded-full border-2 border-white/20">
            <span className="text-purple-100 text-sm font-black tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              GET STARTED
            </span>
          </div>
        </div>

        <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-8 leading-tight" style={{ fontFamily: '"Shippori Mincho", serif', textShadow: '4px 4px 12px rgba(0,0,0,0.5)' }}>
          あなたのビジネスを<br />
          <span className="bg-gradient-to-r from-fuchsia-300 to-violet-300 bg-clip-text text-transparent">次のステージへ</span>
        </h2>

        <p className="text-xl md:text-2xl text-purple-100 mb-12 max-w-3xl mx-auto leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif', textShadow: '2px 2px 6px rgba(0,0,0,0.5)' }}>
          まずはお気軽にご相談ください。<br />
          あなたのビジョンを実現するお手伝いをさせていただきます。
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
          <a 
            href="#contact" 
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-12 py-5 bg-gradient-to-r from-fuchsia-500 to-violet-500 text-white rounded-full font-black text-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl active:scale-95 shadow-xl border-2 border-white/30 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
          >
            無料相談を申し込む
          </a>
          <a 
            href="#services" 
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-12 py-5 bg-white/10 text-white rounded-full font-black text-lg transition-all duration-300 hover:scale-110 hover:bg-white/20 hover:shadow-2xl active:scale-95 shadow-xl border-2 border-white/30 backdrop-blur-sm whitespace-nowrap cursor-pointer"
            style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
          >
            サービスを詳しく見る
          </a>
        </div>

        {/* 特徴アイコン */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {[
            { icon: 'ri-time-line', label: '迅速対応' },
            { icon: 'ri-shield-check-line', label: '安心サポート' },
            { icon: 'ri-award-line', label: '高品質' },
            { icon: 'ri-customer-service-2-line', label: '丁寧な対応' }
          ].map((item, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-xl flex items-center justify-center border-2 border-white/30 shadow-lg">
                <i className={`${item.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-white font-black text-sm" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTA;
